import { IconBell, IconBolt } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { NavLink } from '@/components/ui-shared/NavLink/NavLink'
import { useHasPermissions } from '@/permissions/useHasPermissions'
import { ApplicationNestedPath, buildAppLink } from '@/router/paths'
import { CrudAction, Resource } from '@/types/permissions'
import classes from './AppNavLinks.module.css'

type AppNavLinksProps = {
  appId: string
}

export const AppNavLinks = ({ appId }: AppNavLinksProps) => {
  const [canReadMlModels] = useHasPermissions(Resource.MlModels, [
    CrudAction.Read
  ])

  const [canReadEvents] = useHasPermissions(Resource.Events, [CrudAction.Read])

  return (
    <ul className={classes['app-nav-links']}>
      {canReadMlModels && (
        <NavLink
          icon={<IconBolt />}
          label={<FormattedMessage id="appNav.models" />}
          to={buildAppLink(appId, ApplicationNestedPath.models)}
        />
      )}

      {canReadEvents && (
        <NavLink
          icon={<IconBell />}
          label={<FormattedMessage id="appNav.events" />}
          to={buildAppLink(appId, ApplicationNestedPath.events)}
        />
      )}
    </ul>
  )
}
